var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"broadcast-button-container"},[_c('Button',{attrs:{"text":"broadcast","disabled":!_vm.isActive,"widest":""},on:{"click":_vm.onStartBroadcast}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }